import { render, staticRenderFns } from "./ColorComponent.vue?vue&type=template&id=716ffe4c&scoped=true"
import script from "./ColorComponent.vue?vue&type=script&lang=js"
export * from "./ColorComponent.vue?vue&type=script&lang=js"
import style0 from "./ColorComponent.vue?vue&type=style&index=0&id=716ffe4c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716ffe4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716ffe4c')) {
      api.createRecord('716ffe4c', component.options)
    } else {
      api.reload('716ffe4c', component.options)
    }
    module.hot.accept("./ColorComponent.vue?vue&type=template&id=716ffe4c&scoped=true", function () {
      api.rerender('716ffe4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/ColorComponent.vue"
export default component.exports